<template>
  <div ref="el" :class="[bemClass(), videoLoaded, videoState]">
    <div :class="bemClass('fallback-image')">
      <slot name="fallback-image"></slot>
    </div>
    <sel-button :class="bemClass('play-pause')" v-if="showPlayPauseButton" @click.prevent="playPauseHandler">
      <slot name="play-icon" v-if="!isPlayed" >Play</slot>
      <slot name="pause-icon" v-else>Pause</slot>
    </sel-button>
    <transition name="fade">
      <video :class="bemClass('el')" :data-src="src" :autoplay="autoplay" loop="true" muted="true" playsinline ref="video" :style="videoStyles"></video>
    </transition>
  </div>
</template>

<script>
import { onMounted, ref, computed, toRefs } from 'vue'
import on from 'dom-event'
import useBem from '../../compositions/bem'

export default {
  name: 'SelMp4Video',
  props: {
    src: {
      type: String,
      default: ''
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    showPlayPauseButton: {
      type: Boolean,
      default: true
    },
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const { modifier } = toRefs(props)
    const { bemClass } = useBem('sel-video', modifier)
    const el = ref(null)
    const video = ref(null)
    const videoStyles = ref({})
    const isLoaded = ref(props.showPlayPauseButton)
    const isPlayed = ref(props.autoplay)

    const videoLoaded = computed(() => isLoaded.value ? 'is-loaded' : '')
    const videoState = computed(() => isPlayed.value ? 'is-playing' : 'is-paused')

    function playPauseHandler () {
      if (video.value && isLoaded) {
        if (isPlayed.value) {
          video.value.pause()
          isPlayed.value = false
        } else {
          video.value.play()
          isPlayed.value = true
        }
      }
    }

    function initVideo () {
      const videoEl = video.value
      if (videoEl) {
        videoEl.setAttribute('src', props.src)
        videoEl.onloadeddata = () => {
          updateVideo()
          on(window, 'resize', () => {
            updateVideo()
          })
        }
        videoEl.oncanplaythrough = () => {
          isLoaded.value = true
        }
      }
    }

    function updateVideo () {
      if (getRatio(video.value) > getRatio(el.value)) {
        videoStyles.value = {
          height: 'auto',
          width: '100%'
        }
      } else {
        videoStyles.value = {
          height: '100%',
          width: 'auto'
        }
      }
    }

    function getRatio (el) {
      return el.offsetHeight / el.offsetWidth
    }

    onMounted(() => {
      // TODO: In viewport check
      initVideo()
    })

    return {
      bemClass,
      el,
      video,
      isLoaded,
      isPlayed,
      videoState,
      videoLoaded,
      playPauseHandler,
      videoStyles
    }
  }
}
</script>

<style scoped>
  .sel-video {
    opacity: 0;
    visibility: hidden;
    overflow: hidden;
    transition: opacity 0.25s ease, visibility 0.25s ease;

    &.is-loaded {
      opacity: 1;
      visibility: visible;
    }
  }

  .sel-video__el {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    height: auto;
    width: 100%;
    transform: translate(-50%, -50%);
  }

  .sel-video__play-pause {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate3d(-50%, -50%, 0);
    transition: transform 0.2s;
  }
</style>
